var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStopStroke18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 5H5L5 13H13V5ZM5 3C3.89543 3 3 3.89543 3 5V13C3 14.1046 3.89543 15 5 15H13C14.1046 15 15 14.1046 15 13V5C15 3.89543 14.1046 3 13 3H5Z",
    fill: "black"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMyA1SDVMNSAxM0gxM1Y1Wk01IDNDMy44OTU0MyAzIDMgMy44OTU0MyAzIDVWMTNDMyAxNC4xMDQ2IDMuODk1NDMgMTUgNSAxNUgxM0MxNC4xMDQ2IDE1IDE1IDE0LjEwNDYgMTUgMTNWNUMxNSAzLjg5NTQzIDE0LjEwNDYgMyAxMyAzSDVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K";
export { SvgStopStroke18 as ReactComponent };